import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row gy-3" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "mt-4 fw-normal" }
const _hoisted_4 = { class: "col-12 col-md-4" }
const _hoisted_5 = { class: "col-12 col-md-4" }
const _hoisted_6 = { class: "col-12 col-md-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mt-4 fw-normal" }, "Horario de contacto")
], -1)
const _hoisted_8 = { class: "col-12 col-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormProvinceWithDealer = _resolveComponent("FormProvinceWithDealer")!
  const _component_FormLocalitiesWithDealer = _resolveComponent("FormLocalitiesWithDealer")!
  const _component_FormDealer = _resolveComponent("FormDealer")!
  const _component_FormContactHour = _resolveComponent("FormContactHour")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.t('concesionario.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_FormProvinceWithDealer, {
        modelValue: _ctx.formulario.provincia,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formulario.provincia) = $event)),
        modelModifiers: { number: true }
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_FormLocalitiesWithDealer, {
        modelValue: _ctx.formulario.localidad,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formulario.localidad) = $event)),
        modelModifiers: { number: true },
        provincia: _ctx.formulario.provincia
      }, null, 8, ["modelValue", "provincia"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_FormDealer, {
        modelValue: _ctx.formulario.concesionarioId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formulario.concesionarioId) = $event)),
        modelModifiers: { number: true },
        loacality: _ctx.formulario.localidad
      }, null, 8, ["modelValue", "loacality"])
    ]),
    (!_ctx.getters.isDirectContact)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FormContactHour, {
              modelValue: _ctx.formulario.momentoContacto,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formulario.momentoContacto) = $event)),
              modelModifiers: { number: true }
            }, null, 8, ["modelValue"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}